"use strict";
import CookieConsentForm from "./cookie-consent";

var onloaded = function(f) {
  switch(document.readyState) {
    case 'complete':
      f();
      break;
    case 'interactive':
    case 'loading':
      window.addEventListener('load', f);
  }
}
// https://developer.mozilla.org/de/docs/Web/Events/DOMContentLoaded
onloaded(function() {
  var texts = {
    'h1' : {
      de: 'Diese Webseite verwendet Cookies',
      en: 'Diese Webseite verwendet Cookies'
    },
    '.cookie_consent_details_button' : {
      de: 'Details zeigen',
      en: 'Details zeigen'
    },
    '.description' : {
      de: '<p>Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben.</p><p>Weitere Informationen finden Sie in unserer <a href="https://www.reiner-sct.com/datenschutz.html" target="_blank" rel="noopener noreferrer nofollow">Datenschutzerklärung</a>.</p>',
      en: '<p>Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben.</p><p>Weitere Informationen finden Sie in unserer <a href="https://www.reiner-sct.com/datenschutz.html" target="_blank" rel="noopener noreferrer nofollow">Datenschutzerklärung</a>.</p>'
    },
    '[value="allow_selection"]': {
      de: 'Auswahl erlauben',
      en: 'Auswahl erlauben'
    },
    '[value="allow_all"]': {
      de: 'Cookies zulassen',
      en: 'Cookies zulassen'
    },
    '.cookie_consent_details thead' : {
      de: '<tr><th>Kategorie</th><th>Erläuterung</th></tr>',
      en: '<tr><th>Kategorie</th><th>Erläuterung</th></tr>'
    },
  };

  var categories = {
    necessary: {
      mandatory: true,
      label:  {
	de: "Notwendig",
	en: 'Notwendig'
      },
      text: {
	de: "Pflichtfeld - kann nicht abgewählt werden. Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren.",
	en: "Pflichtfeld - kann nicht abgewählt werden. Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren."
      },
      details: {
	de: "",
	en: ""
      }
    },
    statistics: {
      mandatory: false,
      label:  {
	de: "Statistiken",
	en: 'Statistiken'
      },
      text: {
	de: "Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.",
	en: "Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden."
      },
      details: {
	de: "",
	en: ""
      },
      iframeText: {
	h1: 'Statistik Iframe',
	p: 'wurde ausgeblendet'
      },
      iframeStyle: 'body { background-color: lightblue }',
    },
    marketing: {
      mandatory: false,
      label:  {
	de: "Marketing",
	en: 'Marketing'
      },
      details: {
	de: "",
	en: ""
      },
      text: {
	de: "Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen. Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den einzelnen Benutzer sind und daher wertvoller für Publisher und werbetreibende Drittparteien sind.",
	en: "Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen. Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den einzelnen Benutzer sind und daher wertvoller für Publisher und werbetreibende Drittparteien sind."
      },
    },
    videos: {
      hidden: true, // do not show checkbox
      mandatory: false,
      label:  {
	de: "Eingebettete Videos",
	en: 'embedded videos'
      },
      text: {
	de: "von Youtube geladene, eingebettete Videos",
	en: "embedded videos from Youtube"
      },
      iframeText:  {
	de: {
	  h1: 'Eingebettetes Youtube-Video',
	  p: 'Das Videos wird vom Drittanbieter Youtube geladen.',
	  '#allow_once': 'Video anzeigen',
	  '#allow_all': 'Alle Youtube Videos zulassen',
	},
	en: {
	  h1: 'Embedded Youtube-Video',
	  p: 'This video is loaded form the third party provider Youtube',
	  '#allow_once': 'Show Video',
	  '#allow_all': 'Allow all Youtube videos',
	},
      },
      iframeStyle: 'body {background-color: #fbba00; padding: 2em; } h1 { font-size: 120%;} #textframe { top: 30%; left: 20%; width: 80%; position:absolute;}',
    },
  };

  var cookieConsentForm = new CookieConsentForm(
    document.getElementById('cookie-consent-form'),
    {
      cookie_name: "cookie_consent",
      locale: document.querySelector('html').lang,
      texts: texts,
      categories: categories,
      cookie_attrs: {
	"Max-Age" : 60 * 60 * 24 * 365 * 5, // 5 years
	"SameSite" : "Strict",
	"Path" : "/",
      },
      hide_on_pages: ['/rsct/popup/privacy',
		      '/popup/privacy',
		      '/popup/imprint'],
      html_template: '<form><div class="cookie_consent_main"><h1></h1><div class="description"></div></div><div class="cookie_consent_buttons"><button type="submit" value="allow_selection" /><button type="submit" value="allow_all" /></div><div class="cookie_consent_box"><div class="cookie_consent_row"><div class="cookie_consent_checkboxes"></div><a href="" class="cookie_consent_details_button" /></div></div><table class="cookie_consent_details"><thead /></table></form></div>'
    }
  );
  window.cookieConsentForm = cookieConsentForm;
});
